import {
  MKCard,
  MKCardHeader,
  MKCardTitle,
  MKCardContent,
  MKButton,
} from "@mytraai/mytrakit";

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-secondary">
      <MKCard className="max-w-md w-full">
        <MKCardHeader className="text-center">
          <MKCardTitle className="text-2xl">easybutton</MKCardTitle>
        </MKCardHeader>
        <MKCardContent>
          <MKButton asChild variant="brand" className="w-full py-3">
            <a href="/api/auth/login">Sign in with Google</a>
          </MKButton>
        </MKCardContent>
      </MKCard>
    </div>
  );
}
